import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { Error500Interceptor } from './interceptors/error-500.interceptor';
import { Error500ModalComponent } from './helpers/Error500.component';
import { routes } from './app.routes';
import { loadingInterceptor } from './interceptors/loading.interceptor';
import { authInterceptor } from './interceptors/auth.interceptor';
import { GlobalLoaderComponent } from './helpers/global-loader.component';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([Error500Interceptor, loadingInterceptor, authInterceptor])
    ),
    Error500ModalComponent,
    GlobalLoaderComponent,
  ],
};
